import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import { types } from './constants';
import { defaultContext, PaginationContext, } from './PaginationContext';
import { PaginationControls } from './PaginationControls';
import { ViewAllLink } from './ViewAllLink';
const defaultProps = {
    controlType: types.compact,
};
const Pagination = ({ controlType = defaultProps.controlType, currentPageNumber, hasViewAllLink, isViewAllActive, makeHref, onNextClick, onPageClick, onPrevClick, onViewAllClick, onViewLessClick, totalPages, }) => {
    const paginationContainerStyles = (useMemo(() => (css `
          align-items: center;
          display: flex;
          ${controlType === types.full && css `
             margin-bottom: 0;
             margin-left: auto;
             margin-right: auto;
             margin-top: 0;
          `}
        `), [
        controlType,
    ]));
    const paginationProviderValue = (useMemo(() => (Object.assign(Object.assign({}, defaultContext), { controlType,
        currentPageNumber,
        hasViewAllLink,
        isViewAllActive,
        makeHref,
        onNextClick,
        onPageClick,
        onPrevClick,
        onViewAllClick,
        onViewLessClick,
        totalPages })), [
        controlType,
        currentPageNumber,
        hasViewAllLink,
        isViewAllActive,
        makeHref,
        onNextClick,
        onPageClick,
        onPrevClick,
        onViewAllClick,
        onViewLessClick,
        totalPages,
    ]));
    return (_jsx(PaginationContext.Provider, Object.assign({ value: paginationProviderValue }, { children: _jsxs("div", Object.assign({ css: paginationContainerStyles }, { children: [hasViewAllLink
                    && (_jsx(ViewAllLink, {})), !isViewAllActive
                    && (_jsx(PaginationControls, {}))] })) })));
};
const MemoizedPagination = memo(Pagination);
export { MemoizedPagination as Pagination };
// MC-1068 Temporary hack for Storybook.
export default Pagination;
